/**
 * A global scoped variable to store/cache fetched exchange rates server side.
 * Also provides structure for the rates we are interested in.
 */
const exchangeRatesCache: ExchangeRatesCache = {
    EUR: {
        USD: null,
    },
    SEK: {
        EUR: null,
        USD: null,
    },
}

export default exchangeRatesCache

type ExchangeRatesCache = {
    // The key is the currency currently used / wallet currency
    // -> the currency used to make the final payment.
    [toCurrency: string]: {
        // The currency and exchange rate to convert from. If
        // entry exists, it will be fetched. Value null if not yet fetched.
        [fromCurrency: string]: string | null
    }
}
